import { Component } from '@angular/core';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-custom-first',
    templateUrl: './custom-first.component.html',
    styleUrls: ['./custom-first.component.scss'],
    standalone: false
})
export class CustomFirstComponent {
  node:Observable<any> = this.bannerComponent.data$; 
  constructor(private cmsService:CmsService, protected config: OccConfig,public bannerComponent: CmsComponentData<CmsBannerComponent>) {
  }

getImage(image: any): string {
  return this.config.backend?.occ?.baseUrl + image.desktop.url;
}
getImageLogo(image: any): string {
  return this.config.backend?.occ?.baseUrl + image.url;
}
}